//ユーザ登録(Email)
import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { passwordValidateion } from "../../common/Valitation";
import queryString from 'query-string';
import { HttpPostData, JumpPage } from '../../common/Util';
import { ResponseParamBase } from '../../common/Types';
import { yupResolver } from '@hookform/resolvers/yup';
import { OnsiteTextField, ErrorMessageComp, OnsiteProgress } from "../../customelements/CustomInput";
import { LoginStateConext } from "../../context/AuthContext";
import { TitleParamContext } from '../../context/TitleContext';
import { ResponseParam as LoginResponseParam, LoginInputs } from "../../view/Login";
import { RegisterPageInfo } from '../../context/RegisterPageTypeContext';
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export type RegistEmailParam = {
    mailToken: string
}

export type IFormInputs = {
    password: string,
}

type ResponseParam = ResponseParamBase & {
    registerpagetype: number,
    email: string,
}

type CheckResponseParam = ResponseParamBase & {

}

const schema = Yup.object({
    password: passwordValidateion,
}).required();

export const RegisterEmail = () => {

    const { handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            password: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const location = useLocation();
    const navigate = useNavigate();
    const pageParam = queryString.parse(location.search) as RegistEmailParam;
    const ctx = useContext(LoginStateConext);
    const titleConext = useContext(TitleParamContext);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isCheckLoading, setIsCheckLoading] = useState<boolean>(false);
    const [checkResult, setCheckResult] = useState<CheckResponseParam>({ resultFlg: false, message: "" });


    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setErrorMessage("");
        await HttpPostData<ResponseParam>("/userregister/emailregister", { ...pageParam, password: data.password }, setIsLoading)
            .then(async response => {
                if (response.status === 200) {
                    if (response.data.resultFlg) {
                        //ログインを行う
                        await HttpPostData<LoginResponseParam>("authenticate/login", { email: response.data.email, password: data.password } as LoginInputs, setIsLoading)
                            .then(loginResponse => {
                                if (loginResponse.data.resultFlg) {
                                    ctx.setIsLogin(true);
                                    ctx.setLoginInfo({ email: loginResponse.data.userdata.email, userName: loginResponse.data.userdata.userName });
                                    window.localStorage.setItem("clickeracejwttoken", loginResponse.data.jwtToken);
                                    if (response.data.registerpagetype === 1) {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    } else if (response.data.registerpagetype === 2) {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    } else {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    }
                                }
                            })
                        //登録時のタイプによって遷移先に渡すパラメータを切り替える

                    } else {
                        setErrorMessage(response.data.message);
                    }
                }
            })
            .catch(e => {
                console.log(e);
            })
    }

    useEffect(() => {
        (async () => {
            titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（パスワード確認）" });
            await HttpPostData<CheckResponseParam>("/userregister/registerurlcheck", { emailToken: pageParam.mailToken }, setIsCheckLoading)
                .then(response => {
                    if (response.data.resultFlg) {
                        setCheckResult(response.data);
                    } else {
                        setCheckResult(response.data);
                    }
                })
                .catch(e => {
                    setCheckResult({ resultFlg: false, message: "エラーが発生しました" });
                });
        })()
    }, []);

    return (
        <>
            <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                <section className={market.marketArea}>
                    <div className={market.marketAreaInner}>
                        {isCheckLoading ?
                            <div className={base.flexCenterColumn}><OnsiteProgress></OnsiteProgress></div>
                            :
                            checkResult.resultFlg ?
                                <>
                                    <div className={base.messageFont}>設定したパスワードを入力後、[登録完了] ボタンをクリックすることで、<br/>
                                        本登録（サポート会員登録の完了）となります。</div>
                                    <div className={market["layoutBox-l"]}>
                                        <div className={market.marketInputTitle}>
                                            <h3>パスワード</h3>
                                        </div>
                                        <div className={market.marketInputTitleContents}>
                                            <Controller
                                                name="password"
                                                control={control}
                                                render={({ field }) => (
                                                    <OnsiteTextField
                                                        {...field}
                                                        error={errors.password ? true : false}
                                                        helperText={errors.password?.message}
                                                        margin="normal"
                                                        type="password"
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div className={base.errorMessage}>{errorMessage}</div>
                                    <div className={market.marketFooterArea}>
                                        <button style={{ visibility: "hidden" }} type="button" className={market.marketBackButton}>戻る</button>
                                        <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>登録完了</button>
                                        <button style={{ visibility: "hidden" }} className={market.marketBackButton}>次へ</button>
                                    </div>
                                </>
                                :
                                <>
                                    <ErrorMessageComp message={checkResult.message}></ErrorMessageComp>
                                </>
                        }
                    </div>
                </section>
            </form>
        </>
    );
}